export default __webpack_public_path__ + "static/tenable-6ee39225a80c8a206e45bb0de0b9b641.png";